module.exports = __webpack_public_path__ + "img/relaxation.ad62de4b.svg";